import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcpButtonModule } from 'fc-ui-components';

import { ModalModule } from '../modal.module';
import { UpgradePlanComponent } from './upgrade-plan.component';

@NgModule({
    imports: [CommonModule, TranslateModule, ModalModule, FcpButtonModule],
    declarations: [UpgradePlanComponent],
    exports: [UpgradePlanComponent]
})
export class UpgradePlanModule {}
